/*!

=========================================================
* Paper Kit React - v1.3.1
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container
} from "reactstrap";
import { useOAuth2 } from "@tasoskakour/react-use-oauth2";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, brands } from '@fortawesome/fontawesome-svg-core/import.macro';

function IndexNavbar() {
  // eslint-disable-next-line no-unused-vars
  const { data, loading, error, getAuth } = useOAuth2({
    authorizeUrl: "http://mastodon.local/oauth/authorize",
    clientId: "Xh3FXEAo8_xCECdNnnopVTa8hNWNTNIY2dviMsiQNw4",
    redirectUri: `${document.location.origin}/oauth`,
    scope: "read+write+push",
    responseType: "code",
    exchangeCodeForTokenServerURL: "https://api.hongkongers.net/token",
    exchangeCodeForTokenMethod: "POST",
    onSuccess: (payload) => console.log("Success", payload),
    onError: (error_) => console.log("Error", error_)
  });

  // const isLoggedIn = Boolean(data?.access_token);

  const { t } = useTranslation();
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  const toggleLanguage = () => {
    if (i18n.language !== 'zh-HK') {
      i18n.changeLanguage('zh-HK');
    }
    else {
      localStorage.removeItem('i18nextLng');
      window.location.reload();
    }
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
      <Container>
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"
            href="/index"
            title={t('hometitle')}
          >
            {t('hometitle')}
          </NavbarBrand>
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
            <NavItem>
              <Button
                className="btn-just-icon"
                onClick={toggleLanguage}
              >
                <FontAwesomeIcon icon={solid('language')} size="xl" />
              </Button>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://hkers.social/"
                target="_blank"
                title={t('socialsite')}
              >
                <FontAwesomeIcon icon={brands('mastodon')} size="xl" /> {t('socialsite')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="/about"
              >
                <i className="nc-icon nc-book-bookmark" /> {t('about')}
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <Button
                className="btn-round"
                color="danger"
                onClick={() => getAuth()}
              >
               {t('login_as_pro')}
              </Button>
            </NavItem> */}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;
